import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentLayout  from '../layout/ContentLayout'
const Imprint:React.FC = () => {
  const { t } = useTranslation();
 
  
  return <ContentLayout>
    <h1>{t("impressum.title")}</h1>
    <p></p>
    <h2>{t("impressum.bi.title")}</h2>
    <h3>{t("impressum.bi.cio-title")}</h3>
    <p>{t("impressum.bi.cio")}</p>
    <p></p>
    <h3>{t("impressum.bi.bank.title")}</h3>
    <p>{t("impressum.bi.bank.iban")}</p>
    <p>{t("impressum.bi.bank.bic")}</p>
    <p></p>
    <p>{t("impressum.bi.bank.finanzamt")}</p>
    <p>{t("impressum.bi.bank.hrb")}</p>
    <p>{t("impressum.bi.bank.suid")}</p>
    <p>{t("impressum.bi.bank.sno")}</p>
    <p></p>
    <h2>{t("impressum.ci.title")}</h2>
    <p>proWare Solutions GmbH</p>
    <p>Pirckheimerstr. 124a</p>
    <p>90409 Nürnberg</p>
    <p></p>
    <p>{t("impressum.ci.times")}</p>
    <p>{t("impressum.ci.phone")} <a href="tel:+4991195510884">+49 911 955 10 884</a></p>
    <p>{t("impressum.ci.fax")} <a href="tel:+4991195510887">+49 911 955 10 887</a></p>
    <p>{t("impressum.ci.mobile")} <a href="tel:+4915785933544">+49 1578 5933 544</a></p>
    
    <p>{t("impressum.ci.mail")} <a href="mailto:infor@proware-solutions.de">infor@proware-solutions.de</a></p>
    <p>{t("impressum.ci.web")} <a href="www.proware-solutions.de" target="_blank" >infor@proware-solutions.de</a></p>
    <p></p>
    <h2>{t("impressum.haftung.title")}</h2>
    <p>{t("impressum.haftung.text")}</p>
    <p></p>
    <h2>{t("impressum.links.title")}</h2>
    <p>{t("impressum.links.text")}</p>
  </ContentLayout>

}

export default Imprint;